module.exports = __webpack_public_path__ + "assets/741c170c0bd982d3cf587d3f58d9b689.png";